/*
 * hev-word-street.js: Word on the street (evergreen homepage variant).
 * Looping card carousel (back/next arrows, swipe, arrow keys) and the skate that rolls along the
 * bottom of the panel every 20s: passes alternate direction, and the fifth rolls backwards.
 */
(function () {

  var SKATE_EVERY = 20000;
  var SKATE_DRIVE = 6000;
  var SKATE_FIRST = 1000;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobile = window.matchMedia('(max-width: 749px)');

  function initCarousel(root) {
    var viewport = root.querySelector('[data-hev-street-viewport]');
    var track = root.querySelector('[data-hev-street-track]');
    var controls = root.querySelector('[data-hev-street-controls]');
    var prev = root.querySelector('[data-hev-street-prev]');
    var next = root.querySelector('[data-hev-street-next]');
    var status = root.querySelector('[data-hev-street-status]');
    if (!viewport || !track) return;

    var originals = Array.prototype.slice.call(track.querySelectorAll('[data-hev-street-card]'));
    var count = originals.length;
    if (count < 2) {
      if (controls) controls.hidden = true;
      return;
    }

    function cloneSet(position) {
      var frag = document.createDocumentFragment();
      originals.forEach(function (card) {
        var copy = card.cloneNode(true);
        copy.removeAttribute('data-hev-street-card');
        copy.removeAttribute('aria-roledescription');
        copy.removeAttribute('aria-label');
        copy.removeAttribute('role');
        copy.setAttribute('aria-hidden', 'true');
        copy.setAttribute('inert', '');
        copy.querySelectorAll('a, button').forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
        frag.appendChild(copy);
      });
      if (position === 'before') track.insertBefore(frag, track.firstChild);
      else track.appendChild(frag);
    }

    cloneSet('before');
    cloneSet('after');
    root.classList.add('is-ready');

    var index = 0;
    var pitch = 0;
    var anchor = 0;
    var busy = false;

    function measure() {
      var first = track.children[0];
      var second = track.children[1];
      var cardW = first.getBoundingClientRect().width;
      pitch = second.getBoundingClientRect().left - first.getBoundingClientRect().left;
      anchor = mobile.matches ? (viewport.clientWidth - cardW) / 2 : cardW * (221 / 343.2);
    }

    function place(animate) {
      root.classList.toggle('is-animating', !!animate && !reduceMotion.matches);
      track.style.transform = 'translate3d(' + (anchor - (count + index) * pitch) + 'px,0,0)';
    }

    function announce() {
      if (!status) return;
      var label = originals[((index % count) + count) % count].getAttribute('aria-label') || '';
      status.textContent = label;
    }

    function settle() {
      busy = false;
      if (index >= count || index < 0) {
        index = ((index % count) + count) % count;
        place(false);
      }
    }

    function go(step) {
      if (busy) return;
      busy = !reduceMotion.matches;
      index += step;
      place(true);
      announce();
      if (!busy) settle();
    }

    track.addEventListener('transitionend', function (event) {
      if (event.target === track && event.propertyName === 'transform') settle();
    });

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') { go(1); event.preventDefault(); }
      if (event.key === 'ArrowLeft') { go(-1); event.preventDefault(); }
    });

    var startX = null;
    var startY = null;
    viewport.addEventListener('touchstart', function (event) {
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });
    viewport.addEventListener('touchend', function (event) {
      if (startX === null) return;
      var dx = event.changedTouches[0].clientX - startX;
      var dy = event.changedTouches[0].clientY - startY;
      startX = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
    }, { passive: true });

    var resizeFrame = 0;
    window.addEventListener('resize', function () {
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(function () {
        measure();
        place(false);
      });
    });

    measure();
    place(false);
  }

  /* Drives like the cord skate: a constant-speed run from fully off one edge to fully off
     the other, then out of sight until the next pass. Passes alternate direction; every
     5th runs backwards (the skate keeps facing the way it came). */
  function initSkate(root) {
    var skate = root.querySelector('[data-hev-street-skate]');
    if (!skate || !skate.animate) return;

    var pass = 0;
    var timer = 0;
    var first = 0;
    var visible = false;
    var running = null;

    function span() {
      var rootBox = root.getBoundingClientRect();
      var w = skate.getBoundingClientRect().width;
      return { from: -w - 8, to: rootBox.width + 8 };
    }

    function roll() {
      if (reduceMotion.matches || !visible || document.hidden || running) return;
      pass = (pass % 5) + 1;
      var rightward = pass % 2 === 1;
      var backwards = pass === 5;
      if (backwards) rightward = !rightward;
      var facing = rightward ? 1 : -1;
      if (backwards) facing = -facing;
      var d = span();
      var a = rightward ? d.from : d.to;
      var b = rightward ? d.to : d.from;
      skate.classList.add('is-driving');
      running = skate.animate(
        [
          { transform: 'translateX(' + a + 'px) scaleX(' + facing + ')' },
          { transform: 'translateX(' + b + 'px) scaleX(' + facing + ')' },
        ],
        { duration: SKATE_DRIVE, easing: 'linear' }
      );
      running.onfinish = running.oncancel = function () {
        running = null;
        skate.classList.remove('is-driving');
      };
    }

    function schedule() {
      clearInterval(timer);
      clearTimeout(first);
      if (!visible || reduceMotion.matches) return;
      first = setTimeout(roll, SKATE_FIRST);
      timer = setInterval(roll, SKATE_EVERY);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        schedule();
        if (!visible && running) running.cancel();
      }).observe(root);
    } else {
      visible = true;
      schedule();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden && running) running.cancel();
    });
  }

  function init() {
    document.querySelectorAll('[data-hev-street]').forEach(function (root) {
      initCarousel(root);
      initSkate(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
